import ReadReceiptModal from "./ReadReceiptModal.js";
export default ReadReceiptModal;
